import { render } from "./LoginMondiaUser.vue?vue&type=template&id=4b9e491c"
import script from "./LoginMondiaUser.vue?vue&type=script&lang=js"
export * from "./LoginMondiaUser.vue?vue&type=script&lang=js"

import "./LoginMondiaUser.vue?vue&type=style&index=0&id=4b9e491c&lang=css"

import exportComponent from "/var/www/zaytoon-frontend-base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__